import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useState } from 'react';
import { loginAction } from '../../actions/loginAction';
import { LoadingSpinnerModal } from '../../components/dab';
import { handleTime, getCookie } from '../common/functions';
import { setAuthData } from '../../services/selectors/Accounts';
import moment from 'moment';

interface ILoginProps {
	dispatch: Dispatch<any>;
	loginData: any;
	callback: any;
}

const LoginDetail: React.SFC<ILoginProps> = ({ dispatch, loginData, callback }) => {

	const [isShowForgetPWD, setIsShowForgetPWD] = useState(false);
	const [isRememberMe, setIsRememberMe] = useState(false);
	const [isShowForgetPWDSuccess, setIsShowForgetPWDSuccess] = useState(false);
	const [email, setEmail] = useState("");

	const handleuserNameChange = (event: any) => {
		loginData.loginInput.userName = event.target.value;
	};

	const handlePWDChange = (event: any) => {
		loginData.loginInput.password = event.target.value;
	};

	const handleEmailChange = (event: any) => {
		setEmail(event.target.value);
	};

	const handleSubmit = (e: any) => {
		e.preventDefault();
		loginData.loginInput.isRememberMe = isRememberMe;
		dispatch(loginAction.loginGetDetail(loginData.loginInput));
	};

	const handleForgetPWDSubmit = (e: any) => {
		e.preventDefault();
		dispatch(loginAction.forgotPasswordRequest(email));
	};

	const handleToggleForgotPassword = () => {
		callback("forgotPassword");
		loginData.error = "";
		loginData.isError = false;
		setIsShowForgetPWD(true);
	}

	if (!isShowForgetPWD && loginData && loginData.isSuccess) {
		setAuthData(loginData);
		handleTime();
		const memoryRoute = sessionStorage.getItem('memoryRoute');
		if (loginData && loginData.info && loginData.info.isRememberMe && !loginData.info.isLoginByRefreshToken) {
			const days = Math.ceil((new Date(loginData.expiredAtUtc).getTime() - new Date().getTime()) / (1000 * 3600 * 24));			
			var expire = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * days);
			window.document.cookie = "refreshToken=" + loginData.refreshToken + ";expires=" + expire + ";path=/";
		}
		const roleList = String(loginData.info?.roleCodes ?? '')
			.split(',')
			.map((r) => r.trim())
			.filter(Boolean);
		const isEpisodeRole = roleList.indexOf('Episode') >= 0;
		window.location.href = isEpisodeRole ? '/episode' : (memoryRoute ? memoryRoute : '/')
	}

	if (isShowForgetPWD && loginData && loginData.isSuccess) {
		if (loginData.status !== null) {
			setIsShowForgetPWDSuccess(true);
			loginData.status = null;
		}
	}

	return (
		<div>
			{loginData.isLoading && (<LoadingSpinnerModal isShowModal={loginData.isLoading} modalChange={() => { }} />)}
			{!isShowForgetPWD ?
				<div className='login-page' id="login" data-testid="loginPage">
					{loginData && !loginData.isSuccess && loginData.isError && (
						<div className="alert alert-dismissible alert-danger">
							<text>status { loginData.status }
								Invalid username / password combination.
								If you need to reset your password, click Forgot Password.
								If you have lost your login email address, please use the Contact link
							</text>
						</div>
					)}
					<form onSubmit={event => handleSubmit(event)}>
						<div className="form-group">
							<label htmlFor="username" data-testid="userNameText">Email</label>
							<input data-testid="username" name="username" required={true} id="username" type="text"
								className="is-touched is-dirty av-valid form-control" onChange={handleuserNameChange} />
						</div>
						<div className="form-group" data-testid="passwordText">
							<label htmlFor="password">Password</label>
							<input data-testid="password" name="password" required={true} id="password" type="password"
								className="is-touched is-dirty av-valid form-control" onChange={handlePWDChange} />
						</div>
						<div className="row">
							<a className="frm-forget-link" onClick={handleToggleForgotPassword} data-testid="forgotPasswordLink">Forgot Password?</a>
						</div>
						<div className="row">
							<div className="col-sm-6 remember-me">
								<div data-testid="rememberMeContainer">
									<input type="checkbox" checked={isRememberMe} onChange={(e) => setIsRememberMe(!isRememberMe)}
										className="box-container-input form-check-input" />
									<span data-testid="rememberMeText"> Remember me</span>
								</div>
							</div>
							<div className="col-sm-6">
								<button data-testid="submit" className="btn-submit-frm btn-submit-frmt btn btn-secondary">Login</button>
							</div>
						</div>
					</form>
				</div>
				:
				<div className='login-page' id="login">
					{!loginData.isSuccess && loginData.isError && (
						<div className="alert alert-dismissible alert-danger">
							{loginData.status}.
						</div>
					)}

					{isShowForgetPWDSuccess && loginData.isSuccess && (
						<div className="alert alert-dismissible alert-success" data-testid="passwordResetContainer">
							Password reset link has been sent successfully, Please check your email.
						</div>
					)}

					{!isShowForgetPWDSuccess && (
						<form onSubmit={(e) => handleForgetPWDSubmit(e)}>
							<div className="login-page" id="login" data-testid="forgotPasswordContainer">
								<div className="form-group"><label htmlFor="email" className="" data-testid="forgotPasswordEmailText">Email</label>
									<input name="email" required={true} id="email" type="text" onChange={handleEmailChange}
										className="form-control" data-testid="forgotPasswordValue" />
								</div>
								<button className="btn-submit-frm btn-submit-frmt btn btn-secondary" data-testid="forgotPasswordButton">Send Password Reset</button>
							</div>
						</form>
					)}
				</div>
			}
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { loginData } = state;
	return {
		loginData
	};
};

export default connect(mapStateToProps)(LoginDetail);